import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {WorkerDocumentiDoganaliEmessiModalComponent} from './worker-documenti-doganali-emessi-modal';

export const WorkerDocumentiDoganaliEmessiModalModule: string = ng
    .module('worker-documenti-doganali-emessi-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerDocumentiDoganaliEmessiModalComponent', WorkerDocumentiDoganaliEmessiModalComponent)
    .name;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-documenti-doganali-emessi-modal/worker-documenti-doganali-emessi-modal.module.ts